// React
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// Styles
import styles from './style.module.scss';
import viewsStyles from '../views.module.scss';

// Components
import Typography from '../../../../../../components/Typography';
import Button from '../../../../../../components/CustomButton';

// Context
import { useDataSettingsContext } from '../../context';

interface ViewChangeEmailSuccessProps {
  email: string;
}

const ViewChangeEmailSuccess: React.FC<ViewChangeEmailSuccessProps> = ({ email }) => {
  const { t } = useTranslation();

  // Context
  const { onClose } = useDataSettingsContext();

  // Effects

  return (
    <div className={viewsStyles.container}>
      <Typography variant="p">
        {t('profile.settings.data.change_email.success', { email })}
      </Typography>

      <div className={viewsStyles.actions}>
        <Button
          variant='primary'
          classes={{
            root: viewsStyles.actions_button,
          }}
          onClick={() => onClose()}
        >
          {t('globals.okay')}
        </Button>
      </div>
    </div>
  );
};

export default ViewChangeEmailSuccess;
